import { all, call } from 'redux-saga/effects';
import { userSagas } from 'redux/users/sagas';
import { applicationSagas } from 'redux/applications/sagas';
import { candidateGroupSagas } from 'redux/candidate-group/sagas';
import { notificationSagas } from 'redux/notifications/sagas';
import institutionSaga from 'redux/configurations/sagas';
import newAdminLevelsSagas from 'redux/adminlevels/sagas';
import coursesSaga from './courses/sagas';
import formsSaga from './forms/sagas';
import groupsSaga from './groups/sagas';
import applicantsSaga from './applicants/saga';
import workflowSaga from './workflow/saga';
import workflow2Saga from './workflow2/saga';
import paymentConfigSaga from './payment-configuration/saga';
import transactionHistory from './transaction-history/saga';
import templateSaga from './template/sagas';
import dashboardSaga from './dashboard/saga';
import { filterSaga } from './filters/sagas';
import umsUserSaga from './ums-user-management/sagas';
import { auditLogSagas } from './audit-log/sagas';
import { modificationLogSagas } from './modification-log/sagas';
import couponsSaga from './coupon/sagas';
import directDownloadSaga from './direct-download/saga';
import addonsSaga from './addons/saga';
import aiSaga from './ai/saga';
import intPaymentSaga from './international-payment-configuration/saga';
import limitationSaga from './limitations';
import smsConfigurationSaga from './smsConfiguration/saga';
import { ninLogSagas } from './nin-log/sagas';
import eligibilitySaga from './eligibility/saga';


export default function* rootSaga() {
  yield all([
    call(applicationSagas),
    call(coursesSaga),
    call(limitationSaga),
    call(formsSaga),
    call(groupsSaga),
    call(institutionSaga),
    call(newAdminLevelsSagas),
    call(userSagas),
    call(applicantsSaga),
    call(workflowSaga),
    call(workflow2Saga),
    call(paymentConfigSaga),
    call(intPaymentSaga),
    call(transactionHistory),
    call(templateSaga),
    call(dashboardSaga),
    call(filterSaga),
    call(umsUserSaga),
    call(candidateGroupSagas),
    call(notificationSagas),
    call(auditLogSagas),
    call(couponsSaga),
    call(directDownloadSaga),
    call(modificationLogSagas),
    call(aiSaga),
    call(addonsSaga),
    call(smsConfigurationSaga),
    call(ninLogSagas),
    call(eligibilitySaga),
  ]);
}
